import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import LoggedLayout from '../../components/Layouts/LoggedLayout';
import { queries } from '../../graphql/graphql';
import { Profile } from '../../components/Profile';

const ViewPage = props => {
  const { match } = props;
  const { params } = match;

  const { loading, data = {}, refetch } = useQuery(queries.USER, {
    variables: { id: params.id }
  });
  const { user } = data;

  useEffect(() => {
    refetch();
  }, [data]);

  if (!loading && !user) return <LoggedLayout>User not found.</LoggedLayout>;
  if (loading && !user) return <LoggedLayout>loading...</LoggedLayout>;

  return (
    <LoggedLayout>
      <Profile user={user} />
    </LoggedLayout>
  );
};

export default ViewPage;
